import React from "react";
import { useTranslation } from "react-i18next";

import { IconButton } from "fe-shared/src/components";
import { EditIcon } from "fe-shared/src/components/Icons";

import styles from "./SectionEditAction.module.scss";

interface Props {
  canEdit: boolean;
  editCallback?: () => void;
  actionName?: string;
}

const SectionEditAction = ({
  canEdit,
  editCallback,
  actionName = "Edit",
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.transactionActions}>
        {canEdit && editCallback && (
          <IconButton
            hasTooltip
            onClick={editCallback}
            id="edit-transaction-button"
            aria-label={t(`actions.${actionName}.buttonLabel`)}
            className={styles.editButton}
          >
            <EditIcon fillColor={null} />
          </IconButton>
        )}
      </div>
    </>
  );
};

export default SectionEditAction;
